import { loadConfig } from "@/utils/Config";

export const baseURL = loadConfig().serviceURL + "/apis/v1";

export const APIEndpoints = {
  // Login
  login: "auth/login",
  refreshToken: "auth/refresh-token",
  newRefreshToken: "auth/new-refresh-token",
  settings: "settings",
  retrieveCustomOperatorId: "operator/custom-operator-id",
  retrieveOperatorId: "operator/operator-id",
  forgotPassword: "operator/forgot-password",
  changePassword: "operator/change-password",
  setupPassword: "operator/setup-password",
  changeExpiredPassword: "operator/change-expired-password",
  retrieveAccessorId: "operator/accessor-by-id",
  getAccessProfilesForEnrollment: "enrollment/access-profiles",
  getInsuranceCompaniesForEnrollment: "enrollment/insurance-companies",
  getStatesForEnrollment: "enrollment/states",
  getProductManufacturers: "enrollment/product-manufacturers",
  processEnrollment: "enrollment/process-enrollment",

  // Dashboard
  getAccessorDetails: "accessor/accessor-info",
  getAccessorTransactionInfo: "accessor/accessor-transaction-info",
  getAccessorPrivileges: "accessor/accessor-privileges",

  // Profile
  changePasswordFromProfile: "profile/change-password",
  getContactForProfile: "profile/contact-information",
  updateContactInfoForProfile: "profile/contact-information",
  getAllAccessProfilesForProfile: "profile/all-access-profiles",
  getAccessProfileForProfile: "profile/access-profile",
  updateAccessProfileForProfile: "profile/access-profile",

  // Admin
  approveOrRejectAccessForAdmin: "admin/approve-access",
  searchOperatorForAdmin: "admin/search-operator",
  getAccessRuleAuditHistoryForAdmin: "admin/access-rule-audit-history",
  updateOperatorFromAdmin: "admin/update-operator",
  recordKeepingSystem: "admin/record-keeping-system",
  recordKeepingSystemContact: "admin/record-keeping-system-contact",
  productManufacturersForAdmin: "admin/product-manufacturer",
  productManufacturerContact: "admin/product-manufacturer-contact",
  productManufacturerInsuranceCompanies:
    "admin/product-manufacturer-insurance-companies",
  productManufacturerInvestmentVehicles:
    "admin/product-manufacturer-investment-vehicles",
  managementCompanies: "admin/management-companies",
  investmentVehicles: "admin/investment-vehicle",
  productAdminInvestmentVehicles: "admin/product-investment-vehicle",
  investmentVehiclesAudit: "admin/investment-vehicle-audit",
  insuranceCompany: "admin/insurance-company",
  insuranceCompanyContact: "admin/insurance-company-contact",

  //Product
  productDetails: "product/product-list",
  addUpdateProduct: "product/product",
  productInsuranceCompanies: "product/product-insurance-companies",
  allInsuranceCompanies: "product/all-insurance-companies",
  getInvestmentVehicles: "product/investments",
  getInsuranceCompanies: "product/insurers",
  getProductRules: "product/process-rules",
  duplicateProduct: "product/duplicate-product",
  productRules: "product/product-rules",
  paymentTable: "product/payment-table",
  paymentTableAudit: "product/payment-table-audit",
  withdrawalTable: "product/withdrawal-table",
  contractCertificate: "product/contract-and-certificate",
  checkAccountBalance: "product/check-account-balance",
  purchaseTable: "product/purchase-table",
  getPurchaseTableHistory: "product/purchase-table-audit",
  searchRecordKeepingSystem: "product/search-record-keeping-system",
  getAllTransactionType: "product/all-transaction-types",
  getTransactionMatrix: "product/search-transaction-matrix-entry",
  saveTransactionMatrixEntryTransaction:
    "product/save-transaction-matrix-entry-transaction",
  allInvestmentVehicles: "product/all-investment-vehicles",
  productInvestmentVehicles: "product/investment-vehicles",
  productInvestmentVehiclesAudit: "product/investment-vehicles-audit",
  productInvestmentCompanies: "product/investment-companies",

  // Owner
  searchProductOwnership: "owner/search-ownership",
  inquireProductOwnership: "owner/inquire-ownership",
  getOwnershipInquiry: "owner/inquiry",
  getOwnershipMoneySourceDetails: "owner/money-source",
  getTransactionDetail: "owner/transaction-detail",
  getWithdrawalInquiry: "owner/withdrawal-inquiry",
  updateProductOwnershipJointAnnuitantTransaction: "owner/joint-annuitant",
  saveWithdrawalElection: "owner/withdrawal-election",
  getProductOwnershipJointAnnuitant: "owner/joint-annuitant",
};
